import React from "react";
import { createRoot } from "react-dom/client";
import { SearchWatchdogButton } from "../serppage/watchdog/SearchWatchdogButton";

export default class SerpPageService {
    public init(): void {
        const searchQuery = new URLSearchParams(window.location.search).get("q") ?? "";
        const rootElement = document.querySelector<HTMLElement>(".search-watchdog-root");

        if (rootElement) {
            const root = createRoot(rootElement);
            root.render(React.createElement(SearchWatchdogButton, { searchQuery }));
        }
    }
}
